export default {
    setIsLoading(state, value) {
        state.isLoading = value
    },
    setIsAgree(state, value) {
        state.isAgree = true
    },
    setIsFixed(state, value) {
        state.isFixed = value
    }
}



// WEBPACK FOOTER //
// ./src/vuex/mutation.js